import { BatchClassConfig } from "../../models/config/BatchClassConfig";
import { BatchClassMetadataData } from "../../models/config/BatchClassMetadata";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTActionBarBatchClass } from "../tooltips/ConfigurationTooltips";
import { FilterableActionBarCategory } from "./FilterableActionBarCategory";
import { Text } from "./items/Text";

export { BatchClassCategory };

type Props = {
  batchClassConfig?: BatchClassConfig;
  batchClassConfigs: BatchClassMetadataData[];
  changeBcc: (batchClassConfig: BatchClassMetadataData) => void;
};

const BatchClassCategory = (props: Props) => {
  const batchClassCategoryTitle = `${props.batchClassConfig?.batchClassId} - ${props.batchClassConfig?.batchClassName}`;
  return (
    <AdvancedTooltip
      overflow
      tooltipText={TTActionBarBatchClass}
      possiblePlacements={["left-center"]}
    >
      {(tProps) => (
        <FilterableActionBarCategory
          tProps={tProps}
          title={props.batchClassConfig ? batchClassCategoryTitle : ""}
          // stretch to width of children
          stretch
          list={props.batchClassConfigs}
        >
          {(bcc, itemProps) => (
            <Text
              {...itemProps}
              key={bcc.batchClassId}
              onClick={() => props.changeBcc(bcc)}
            >
              <>
                {bcc.batchClassId} - {bcc.name}
              </>
            </Text>
          )}
        </FilterableActionBarCategory>
      )}
    </AdvancedTooltip>
  );
};
